import { createTheme } from "@mui/material/styles";
import { brandColors } from "../LandingPage.theme";

const adminTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: brandColors.tealLight,
      light: brandColors.emeraldLight,
      dark: brandColors.emeraldDark,
      contrastText: "#ffffff",
    },
    secondary: {
      main: brandColors.amber,
      light: brandColors.amberLight,
      dark: "#C98A12",
      contrastText: brandColors.ink,
    },
    background: {
      default: "#F4FBF8",
      paper: "#ffffff",
    },
    text: {
      primary: brandColors.ink,
      secondary: "#4B6B64",
    },
    success: { main: brandColors.sGreen },
    warning: { main: "#d97706" },
    error: { main: "#dc2626" },
    info: { main: "#0891b2" },
    divider: "rgba(17, 59, 54, 0.1)",
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: [
      '"Sanchez"',
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      "Helvetica",
      "Arial",
      "sans-serif",
    ].join(","),
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          scrollbarWidth: "thin",
          scrollbarColor: "rgba(17, 59, 54, 0.25) transparent",
        },
        "*::-webkit-scrollbar": {
          width: 6,
          height: 6,
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(17, 59, 54, 0.25)",
          borderRadius: 8,
        },
        "*::-webkit-scrollbar-track": {
          backgroundColor: "transparent",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "0 1px 2px rgba(11, 43, 38, 0.06)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0 1px 3px rgba(11, 43, 38, 0.08)",
          border: "1px solid #DCEEE8",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
          boxShadow: "0 12px 32px rgba(11, 43, 38, 0.16)",
          border: "1px solid #DCEEE8",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: brandColors.ink,
          fontSize: 12,
          fontWeight: 500,
          padding: "6px 10px",
          borderRadius: 6,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: "none",
          "--DataGrid-rowBorderColor": "#EFF8F4",
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#F4FBF8",
            borderBottom: "1px solid #DCEEE8",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: 12,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.04em",
            color: "#4B6B64",
          },
          "& .MuiDataGrid-columnSeparator": { display: "none" },
          "& .MuiDataGrid-cell": {
            borderBottom: "1px solid #EFF8F4",
          },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-row": {
            cursor: "pointer",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#F4FBF8",
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "1px solid #DCEEE8",
          },
          "& .MuiDataGrid-overlay": {
            backgroundColor: "rgba(255,255,255,0.6)",
          },
        },
      },
    },
  },
});

export default adminTheme;
